<div class="container">
  <div class="col-sm-12 breadcrumb py-3 m-0">
    <a href="#">Livraison</a>
  </div>
</div>
<div class="container-fluid check">
        <div class="row">
            <div class="col-sm-12">
                <div class="sousTitreRubriqueLeft">
                Livraison
                </div>
                <div class="separApropos"></div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-sm-8">
                <form class="checkoutForm">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                        <label class="form-check-label" for="inlineCheckbox1">Personne physique :</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                        <label class="form-check-label" for="inlineCheckbox2">Sociète :</label>
                      </div>
                      <div class="row">
                        <div class="col">
                          <input type="text" class="form-control" placeholder="Nom complet">
                        </div>
                        <div class="col">
                          <input type="text" class="form-control" placeholder="Adresse">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <input type="text" class="form-control" placeholder="Référence client">
                        </div>
                        <div class="col">
                        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email">
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <input type="text" class="form-control" placeholder="Ville ">
                        </div>
                        <div class="col">
                        <input type="tel" id="phone" class="form-control" name="phone" placeholder="Téléphone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}">
                        </div>
                      </div>
                      <div class="row">
                          <div class="col-md-6">
                            <button type="submit" class="btn btn-primary voirPlusBtnRouge">Enregistrer et confirmer</button>
                          </div>
                          <div class="col-md-6">
                            <a href="http://127.0.0.1:5500/Ceratube/panier.html"><button type="submit" class="btn btn-primary voirPlusBtn">Retour au panier</button></a>
                        </div>
                      </div>
                  </form>
            </div>
            <div class="col-md-2"></div>
        </div>
    </div>
